import { useEffect, useState } from 'react';

const BuildVersion = () => {
  const [buildVersion, setBuildVersion] = useState(null);

  useEffect(() => {
    // Get the build version from the meta tag with build-version attribute
    const metaTag = document.querySelector('meta[build-version]');
    if (metaTag && metaTag.getAttribute('build-version')) {
      const version = metaTag.getAttribute('build-version');
      // Only set if it's not the placeholder
      if (version !== '%REACTBUILDVERSION%') {
        setBuildVersion(version);
      }
    }
  }, []);

  if (!buildVersion) {
    return null;
  }

  return <span> | Last Build: {buildVersion}</span>;
};

export default BuildVersion;
